(function (ws) {
    'use strict';

    ws.views.sessionModal = ws.views.modal.extend({
        events: {
            'click .sessionContinue': 'sessionContinue'
        },

        initialize: function () {
            console.log('Initialize');
        },

        // function to kill session
        sessionContinue: function() {
            this.eventAgg.trigger('continueSession');
        }
    });

})(westcon);
